<template lang="pug">
  .d-inline-block.alert.alert-outline.alert-outline-success.alert-outline__fixed-top.fade(
    :class="{show: flag}",
    role="alert"
  )
    .d-flex.position-relative
      i.fal.fa-check-circle.alert-icon
      .alert-text
        | ルームURLをクリップボードにコピーしました
</template>

<script>
export default {
  name: 'Alert',
  computed: {
    flag () {
      return this.$store.state.showAlert
    }
  }
}
</script>
